import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './config/app.config';
import { of } from 'rxjs';
import { CacheService } from './cache.service';
var TmxLookupJson = [];
@Injectable({
  providedIn: 'root'
})

export class LookupService extends DataService {
  lookupByType:any;
  lookups: any = {};
  flag: Boolean = false;
  constructor(appConfig:AppConfig,http: HttpClient) {
    super(appConfig,http);
}
getAllLookups() {
  const lookups = CacheService.get('Lookups');
  if (lookups) {
    this.flag = true;
    return of(lookups); // creates an observable of the object
  }
  return this.getByAction('Lookup/');
}
  saveLookups(lookups)
  {
    TmxLookupJson = lookups;
    this.groupLookupByType();
    this.LookupById(TmxLookupJson);
  }

  groupLookupByType()
  {
    this.lookupByType = _.groupBy(TmxLookupJson, 'LookupType');
  }

  getLookupByTypeAndParentId(LookupType,ParentId)
  {
    if(ParentId)
    {
      if(this.lookupByType[LookupType])
      {
        return this.lookupByType[LookupType].filter(item => {
          return item.ParentLookupId == ParentId;
        });
      }
      else
      {
        console.log(LookupType + ' LookUp does not exists');
        return [];
      }

      
    }
    else
    {
      if(this.lookupByType[LookupType])
      {
        return this.lookupByType[LookupType];
      }
      else
      {
        return [];
      }
      
    }
  }

  LookupById<T>(array: Array<T>) {
    for (let i = 0; i < array.length; i++) {
         const key = array[i]['LookupId']
         this.lookups[key] = array[i]
    }
    return this.lookups as { [key: string]: T }
}

  getLookupById(LookupId)
  {
      return this.lookups[LookupId];
  }

  getLookupByType(LookupType)
  {
      return this.lookupByType[LookupType];
  }
}
